import axios from 'axios';
import actionHelpers from '../../utils/action-helpers';
import { buildUrl } from '../../utils/helpers';
import { getById, getAll, getBySlug } from '../../utils/getter-helpers';
import {
  UPDATE_STATUS,
  RESET_ERRORS,
  SET_ERROR,
  SET_ITEMS,
  ADD_ITEMS,
  ADD_ITEM,
  UPDATE_ITEM,
  REMOVE_ITEM,
  SET_NEXT_URL,
  CLEAR_ITEMS,
  UPDATE_DISPLAY_STYLE,
  SORT_ITEMS
} from '../../utils/mutation-helpers';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  heading: 'Accessories',
  description:
    'Most My Little Ponies came with some fun accessories. Some came with brushes, ribbons, and a sticker. Some came with their own toys.',
  nextUrl: null,
  total: null,
  errors: [],
  filters: {
    category: [],
    color: []
  },
  displayStyle: 'grid',
  sort: {
    direction: 'asc',
    field: 'name'
  }
};

// getters
const getters = {
  getByPonyId: state => ponyId => {
    return state.items.filter(o => {
      if (Array.isArray(o.ponies)) {
        return o.ponies.find(p => p.id === +ponyId);
      }
    });
  },
  getById,
  getAll,
  getBySlug,
};

// actions
const actions = {
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_PONY_ACCESSORIES: async ({ commit }, { slug }) => {
    try {
      const url = `${path}/api/pony/${slug}/accessories`;
      const { data: { data: { items } } } = await axios.get(url);

      if (items) {
        // const filteredItems = items.filter(o => {
        //   const inList = state.items.find(p => {
        //     return p.id === o.id;
        //   });
  
        //   return !inList;
        // });
  
        // if (filteredItems) {
        //   items = filteredItems;

        //   commit('ADD_ITEMS', data);
        // }

        return items;
      }

      return [];
    } catch (error) {
      commit('SET_ERROR', error);
      throw new Error(error);
      // dispatch(
      //   'notification/ERROR_NOTIFICATION',
      //   'could not fetch accessories for this pony. try again later.',
      //   { root: true }
      // );
    }
  },
  FETCH_ALL: ({ commit, dispatch }, { num }) => {
    // fetch an initial list of accessories
    commit('CLEAR_ITEMS');

    const sort = () => {
      dispatch('SORT', {
        direction: state.sort.direction,
        field: state.sort.field
      });
    };

    actionHelpers.FETCH_ALL(`${path}/api/accessories/${num}`, sort)({
      commit,
      dispatch
    });
  },
  FETCH_MORE: ({ commit, dispatch }, { nextUrl }) => {
    // fetch the next page of accessories if there is a next page
    actionHelpers.FETCH_MORE(nextUrl)({ commit, dispatch });
  },
  FETCH: ({ commit, dispatch }, { slug }) => {
    actionHelpers.FETCH(`${path}/api/accessory/${slug}`)(
      { commit, dispatch },
      slug,
      state
    );
  },
  UPDATE_FILTERS: ({ commit, dispatch }, payload) => {
    commit('UPDATE_FILTERS', payload);
    dispatch('FILTER');
  },
  FILTER: async ({ commit, dispatch }) => {
    commit('UPDATE_STATUS', 'loading');
    let url = buildUrl(`${path}/api/accessories/`, state.filters);

    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('SET_ITEMS', data);
    } catch (error) {
      commit('UPDATE_STATUS', 'error');
      console.error(error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  },
  ADD: async ({ commit, dispatch }, payload) => {
    actionHelpers.ADD(`${path}/api/accessory/create`)(
      { commit, dispatch },
      payload
    );
  },
  UPDATE: async ({ commit, dispatch }, payload) => {
    actionHelpers.UPDATE(`${path}/api/accessory/${payload.slug}`)(
      { commit, dispatch },
      payload
    );
  },
  REMOVE: async ({ commit, dispatch }, { slug }) => {
    actionHelpers.REMOVE(`${path}/api/accessory/${slug}`)(
      { commit, dispatch },
      { slug }
    );
  },
  SET_ERROR: ({ commit }, { errors }) => {
    commit('SET_ERROR', errors);
  },
  CHANGE_DISPLAY_STYLE: ({ commit }, { display }) => {
    commit('UPDATE_DISPLAY_STYLE', { display });
  },
  SORT: ({ commit }, { direction, field }) => {
    commit('SORT_ITEMS', { direction, field });
  },
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
};

const mutations = {
  UPDATE_FILTERS: (state, { name, value }) => {
    const filters = { ...state.filters };
    let selectedFilter = filters[name];

    if (Array.isArray(selectedFilter)) {
      if (selectedFilter.find(o => o === value)) {
        selectedFilter = selectedFilter.filter(o => o !== value);
      } else if (selectedFilter) {
        selectedFilter.push(value);
      } else {
        console.warn(`there is no filter ${name}`);
      }
    } else {
      console.error('empty filter list');
    }

    state.filters = filters;
  },
  SORT_ITEMS,
  UPDATE_STATUS,
  RESET_ERRORS,
  SET_ERROR,
  SET_ITEMS,
  ADD_ITEMS,
  ADD_ITEM,
  UPDATE_ITEM,
  REMOVE_ITEM,
  SET_NEXT_URL,
  CLEAR_ITEMS,
  UPDATE_DISPLAY_STYLE,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
